<app-nav-sidebar>
  <app-alert></app-alert>
  <router-outlet></router-outlet>
</app-nav-sidebar>
